import axios, {
	type AxiosError,
	type AxiosInstance as AxiosInstanceType,
} from "axios";
import {
	Configuration,
	type ConfigurationParameters,
	StorefrontApi,
} from "@/lib/storefront-api";

// the runtime basePath is set after appconfig.json loads via setStorefrontSdkBasePath()
const apiConfigParams: ConfigurationParameters = {
	basePath: "http://localhost:57949",
};

export const apiConfig = new Configuration(apiConfigParams);

// erase the base headers, since they were sticking in a User-Agent, which is no longer allowed in the browser
apiConfig.baseOptions = {
	...apiConfig.baseOptions,
	headers: {
		// any existing headers from baseOptions would go here if needed
		// but we are explicitly clearing User-Agent, so we start fresh or merge carefully
	},
};

// Create a new Axios instance for the SDK
export const sdkAxiosInstance: AxiosInstanceType = axios.create();

// Add a response interceptor to the SDK's Axios instance
sdkAxiosInstance.interceptors.response.use(
	(response) => response,
	(error: AxiosError) => {
		if (error.response && error.response.status === 401) {
			// Clear auth-related localStorage items
			//   localStorage.removeItem('portal.auth.isAuthenticated');
			//   localStorage.removeItem('portal.auth.fullname');
			//   localStorage.removeItem('portal.auth.email');
			//   localStorage.removeItem('portal.auth.dealid');
			//   localStorage.removeItem('portal.auth.deal');
			// Redirect to login page
			//   if (window.location.pathname !== '/portal/login') {
			//     window.location.href = '/portal/login';
			//   }
		}
		return Promise.reject(error);
	},
);

// Pass the configured apiConfig and the custom Axios instance to the API clients
export const storefrontSdk = new StorefrontApi(
	apiConfig,
	undefined,
	sdkAxiosInstance,
);

export const setStorefrontSdkBasePath = (basePath: string) => {
	const normalizedBasePath = basePath.replace(/\/+$/, "");
	apiConfig.basePath = normalizedBasePath;
	sdkAxiosInstance.defaults.baseURL = normalizedBasePath;
};
